import styled from 'styled-components';
import CallToAction from 'contentful/shared/call_to_action';
import RTECompose from 'contentful/RTE_compose';
import toRem from 'utils/toRem';
import ContentfulImageRenderer from './image_renderer';
import Container from './shared/container';
import Grid from './shared/grid';
import SectionTOC from '../components/evergreen/section_TOC';

const HeroBanner = ({
  fields: {
    banner,
    title,
    content,
    callToAction,
    columns,
    alignment,
    backgroundColor,
    fullWidth,
    contentsTitle,
    includeContents = false,
  },
  pageContent,
}) => (
  <Banner
    backgroundColor={backgroundColor}
    isFullWidth={fullWidth}
    className="hero-banner"
    style={{ textAlign: alignment }}>
    <Grid cols={1} rowGap={32}>
      {banner && !!Object.keys(banner).length && <Image image={banner} />}
      <Grid
        className="hero-banner__content"
        cols={columns}
        colGap={64}
        rowGap={32}>
        {title && <Title>{title}</Title>}
        {(content || callToAction) && (
          <div>
            {content && <RTECompose content={content} fieldType="content" />}
            {callToAction && (
              <CallToAction
                className="mt-32"
                id={callToAction.sys.id}
                content={callToAction.fields}
                newTab
              />
            )}
          </div>
        )}
      </Grid>
    </Grid>
    {includeContents && (
      <SectionTOC
        title={contentsTitle}
        content={pageContent}
        backgroundColor={backgroundColor}
        alignment={alignment}
      />
    )}
  </Banner>
);

const Banner = styled(Container)`
  p {
    font-size: ${toRem(20)};
    line-height: ${toRem(28)};
  }
`;

const Image = styled(ContentfulImageRenderer)`
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  font-size: ${toRem(48)};
  line-height: ${toRem(58)};
  font-weight: 800;
  margin: 0;
`;

export default HeroBanner;
